import { memo } from 'react';
import { Swipe } from './swipe';
import { useBanners } from './bannerAdScript';
import './index.scss';

const News = memo(() => {
    const bannersTr = useBanners({
        enable: true,
        product: 'GL'
    });

    return <Swipe bannerArr={bannersTr} />;
});

News.displayName = 'News';

export default News;